import React, {useState, useEffect} from "react";

import {
	Box,
    Button,
    InputAdornment,
    TextField,
} from '@mui/material';


import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import SearchIcon from '@mui/icons-material/Search';

import api from '../../../../api';
import {getSession} from '../../../../auth';
import Loading from '../../../Loading';
import useNotification from "../../../Notification";
import ConfirmationDialog from '../../../Dialogs/Confirmation';

import EditGroupNameModal from "../EditGroupNameModal";
import EditGroupMembersModal from "../EditGroupMembersModal"

import '../../styles.css';

function ClientGroupList(props) {
    const enterpriseId = props.enterpriseId
    const [onLoading, changeLoading] = useState(false)
    const [clientGroupData, updateClientGroupData] = useState([])
    const [editClientGroupModal, updateClientGroupModal] = useState(false)
    const [selectedKey, updateSelectedKey] = useState(0)
    const [deleteClientGroupModal, updateDeleteClientGroupModal] = useState(false)
    const [editGroupMembersModal, updateEditGroupMembersModal] = useState(false)
    const [filteredGroups, updateFilteredGroups] = useState([])




    const editClientGroup = (data) => {
        updateClientGroupModal(true)
        updateSelectedKey(data.id)
        updateClientGroupData(data)
    }

    const handleEditGroupMembers = (data) => {
        updateEditGroupMembersModal(true)
        updateSelectedKey(data.id)
        updateClientGroupData(data)
    }

    const deleteClientGroup = (data) => {
        updateDeleteClientGroupModal(true)
        updateSelectedKey(data.id)
    }

    const filterInputValue = () => {
        
        const handleFilterChange = (event) => {
            // Apply the filter by clicking the Enter key
                filterGroups(event.target.value)               
            
        };
        return (
            <Box>
                <TextField
                    className={'inputPlaceholder'}
                    label={"Buscar Segmentos"}
                    defaultValue=""
                    onChange={handleFilterChange}
                    variant="standard"
                    InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                />
            </Box>
        )
    }

    const filterGroups = (searchString) => {
        updateFilteredGroups(props.groups.filter((group) => 
            group.name.includes(searchString)
        )
    )}

    useEffect(() =>{
        updateFilteredGroups(props.groups)
    }, [props.groups])

    const submitDeleteGroup = async () => {
        changeLoading(true)
        const url = `/api/enterprises/${enterpriseId}/contact_group/${selectedKey}/`;
        const response = await api.delete(url)
        props.changeUpdate()
        changeLoading(false)
        useNotification(
            'Sucesso!',
            'Segmento deletado!',
            'success'
        );
    }

    const submitEditModal = (event) => {
        changeLoading(true)
        updateClientGroupModal(false)
        updateEditGroupMembersModal(false)
        props.changeUpdate()
        updateSelectedKey(0)
        changeLoading(false)
        useNotification(
            'Sucesso!',
            'Segmento atualizado!',
            'success'
        );
    }

    const closeAllModal = () => {
        updateClientGroupModal(false)
        updateEditGroupMembersModal(false)
        updateDeleteClientGroupModal(false)
        updateSelectedKey(0)
    }

    const canCreateSegments = getSession().groups.filter(each => each.name === 'administrador' || each.name === 'supervisor').length > 0 
    ? true: getSession().profile.enterprise.settings.agent_can_create_segments


    return (
        <>
        <Loading loading={onLoading} />
        <>
            <Box sx={{"marginBottom":".25rem"}}>
                {props.childObject}
            </Box>
            <Box sx={{"padding":"0 0.4rem"}}>
                {filterInputValue()}
            </Box>
            <Box className='group-list-flexbox'>
                {
                    filteredGroups.length == 0 ? <Box>Nenhum segmento encontrado...</Box> : filteredGroups
                    .map( group => 
                        <Box key={`each-group-${group.id}`} className="segment-item">
                            <span onClick={() => {props.parent.filterOnClick(group.name)}} className="each-group-name">{group.name}</span>
                            {
                            canCreateSegments &&
                            <Box className="each-group-div">
                                <Button onClick={() => {}}>
                                    <MoreHorizIcon />
                                    <Box  className={'groupDropDown'}>
                                        <Button onClick={() => editClientGroup(group)} className='groupOption'>Editar</Button>
                                        <Button onClick={() => handleEditGroupMembers(group)} className='groupOption'>Ver membros</Button>
                                        <Button onClick={() => deleteClientGroup(group)} className='groupOption'>Excluir</Button>
                                    </Box>
                                </Button>
                            </Box>
                            }
                        </Box>
                        
                    )
                } 
            </Box>
            </>
        <ConfirmationDialog open={deleteClientGroupModal}
            title="Confirmação"
            description="Tem certeza que deseja excluir o segmento selecionado?"
            handleClose={closeAllModal}
            handleSubmit={submitDeleteGroup}
        />
        <EditGroupNameModal
                open={editClientGroupModal}
                title="Editar Segmento"
                buttonText="Salvar"
                data={clientGroupData}
                handleClose={closeAllModal}
                submit={submitEditModal}
                clients={props.clients}
                enterpriseId={props.enterpriseId}
                groupId={selectedKey}
        />
        <EditGroupMembersModal
                open={editGroupMembersModal}
                title="Editar Segmento"
                buttonText="Salvar"
                data={clientGroupData}
                handleClose={closeAllModal}
                submit={submitEditModal}
                clients={props.clients}
                enterpriseId={props.enterpriseId}
                groupId={selectedKey}
        />
       
        </>
    )
}

export default ClientGroupList
